import type {
  ConsentListener,
  ConsentProvider,
  ConsentSnapshot,
} from '@/Integrations/Consent/types';
import { loadExternalScript } from '@/Integrations/Shared/scriptLoader';
import {
  readCookiebotSnapshot,
  watchCookiebotConsent,
} from '@/Integrations/Consent/providers/nativeConsent';

interface CookiebotProviderOptions {
  id: string;
}

export function createCookiebotProvider(options: CookiebotProviderOptions): ConsentProvider {
  const listeners = new Set<ConsentListener>();

  const blockingMode = 'auto';

  let snapshot: ConsentSnapshot = {
    functional: true,
    analytics: false,
    marketing: false,
    source: 'default',
    updatedAt: Date.now(),
  };

  const publish = (next: ConsentSnapshot) => {
    snapshot = next;
    listeners.forEach((listener) => listener(snapshot));
  };

  return {
    name: 'cookiebot',
    async init() {
      watchCookiebotConsent(publish);

      await loadExternalScript({
        key: `cmp:cookiebot:${options.id}:${blockingMode}`,
        src: 'https://consent.cookiebot.com/uc.js',
        attributes: {
          id: 'Cookiebot',
          'data-cbid': options.id,
          'data-blockingmode': blockingMode,
          type: 'text/javascript',
        },
      });

      publish(readCookiebotSnapshot());
    },

    getSnapshot() {
      return snapshot;
    },

    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
